module.exports = __webpack_public_path__ + "static/media/l-web-kids.8e8acab6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/atoms/Nav/l-web-kids.svg
// module id = 580
// module chunks = 0